import { Button, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const ContAppCont = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
  display: 'flex',
  flexDirection: 'column',
}));

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  borderBottom: `1px solid ${theme.palette.type === 'dark' ? '#2d3748' : '#e0e0e0'}`,
  padding: '0 5px 0 20px',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const Body = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px 20px 0px 20px',
}));

export const Note = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
}));

export const Footer = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: 20,
  gap: 20,
}));

export const GoToProjectButton = styled(Button)(({ theme }) => ({
  marginRight: 'auto',
  backgroundColor: 'transparent',
  border: '1px solid',
  borderColor: COLORS.PRIMARY,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
  boxShadow: 'none',
  '&:hover': {
    color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
    backgroundColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
    boxShadow: 'none',
  },
}));
